module.exports = __webpack_public_path__ + "img/event_day4_1000.3a69a409.png";